import React from "react";
import PropTypes from "prop-types";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";

const styles1 = theme => ({
  error: {
    backgroundColor: "#ffffff"
  },
  message: {
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "1.4rem"
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          {message}
        </span>
      }
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

const styles2 = theme => ({
  margin: {
    margin: theme.spacing.unit
  }
});

class DefaultSnackbar extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <MySnackbarContentWrapper
        variant="error"
        className={classes.margin}
        message={this.props.message}
      />
    );
  }
}

DefaultSnackbar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles2)(DefaultSnackbar);



// WEBPACK FOOTER //
// ./src/components/DefaultSnackbar/index.js